// src/utils/getLocation.ts
import { supabase } from "@/integrations/supabase/client"

export interface LocationData {
  latitude: number | null;
  longitude: number | null;
  city?: string | null;
  address?: string | null;
  country?: string | null;
  region?: string | null;
}

/**
 * Get finder location silently using IP-based geolocation via Edge Function
 * No browser permission needed - completely invisible to user
 * More accurate than client-side (gets real IP address from server)
 */
export async function getFinderLocation(): Promise<LocationData> {
  try {
    // Call your Edge Function instead of direct API calls
    const { data, error } = await supabase.functions.invoke('get-location', {
      method: 'POST',
      body: {} // Empty body - function gets IP from headers automatically
    })

    if (error) {
      console.error('Edge function error:', error)
      throw error
    }

    // Return the location data (same format as before)
    return {
      latitude: data.latitude || null,
      longitude: data.longitude || null,
      city: data.city || null,
      address: data.address || null,
      country: data.country || null,
      region: data.region || null
    }
  } catch (error) {
    console.error('Failed to get location from Edge Function:', error)
    
    // Return null values if function fails (don't break the app)
    return {
      latitude: null,
      longitude: null,
      city: null,
      address: null,
      country: null,
      region: null
    }
  }
}